import React from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { AccountType } from './types';
import { InputWrapper } from './styles';

type Props = {
  visible: boolean;
  onClose: () => void | Promise<void>;
  accountType: AccountType;
  onChangeType: (t: AccountType) => void;
  onNext: () => void;
};

const TypeDialog: React.FC<Props> = ({ visible, onClose, accountType, onChangeType, onNext }) => (
  <DialogComponent
    visible={visible}
    width="400px"
    isModal
    showCloseIcon
    header="Account-Typ auswählen"
    close={onClose}
    buttons={[
      {
        buttonModel: { content: 'Weiter', cssClass: 'e-custom modal-dialog-btn' },
        click: onNext,
      },
    ]}
  >
    <div style={{ padding: 16 }}>
      <InputWrapper>
        <DropDownListComponent
          dataSource={[
            { name: 'E-Mail (IMAP + SMTP)', value: 'email' },
            { name: 'Key/Value (Credentials)', value: 'credentials' },
          ]}
          value={accountType}
          fields={{ text: 'name', value: 'value' }}
          change={(e: any) => onChangeType(e.value as AccountType)}
        />
      </InputWrapper>
    </div>
  </DialogComponent>
);

export default TypeDialog;
